"use client";
import React, { createContext, useContext, useState } from "react";
import { getCurrencyFromCookie } from "@/lib/currency/cookieUtils";

interface ConvertedPriceData {
  price: number;
  currencyCode: string;
}

interface UserPreferencesContextType {
  selectedCurrency: string;
  setSelectedCurrency: React.Dispatch<React.SetStateAction<string>>;
  convertedPrice: ConvertedPriceData | null;
  setConvertedPrice: React.Dispatch<
    React.SetStateAction<ConvertedPriceData | null>
  >;
}

const UserPreferencesContext = createContext<
  UserPreferencesContextType | undefined
>(undefined);

export function UserPreferencesProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const currencyFromCookie = getCurrencyFromCookie();
  const [selectedCurrency, setSelectedCurrency] = useState(currencyFromCookie);
  const [convertedPrice, setConvertedPrice] =
    useState<ConvertedPriceData | null>(null);

  return (
    <UserPreferencesContext.Provider
      value={{
        selectedCurrency,
        setSelectedCurrency,
        convertedPrice,
        setConvertedPrice,
      }}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
}

export const useUserPreferencesContext = () => {
  const context = useContext(UserPreferencesContext);
  if (context === undefined) {
    throw new Error(
      "useUserPreferencesContext must be used within a UserPreferencesProvider",
    );
  }
  return context;
};
